import React, { useState } from 'react';
import { useListingTimedEntryExperimentContext } from '../../../contexts/ListingTimedEntryExperimentContext';
import { useCondensedCheckout } from '../../../experimentation/useCondensedCheckout';
import {
    Event,
    LegacyConversionBarProps,
    LocalizedDateTime,
} from '../../../types';
import { AnimatedConversionBar } from './AnimatedConversionBar';
import { CheckAvailability } from './ConversionBar/CheckAvailability';
import { ConversionBarComponentProps } from './ConversionBar/ConversionBar';
import { ConversionBarContent } from './ConversionBarContent/ConversionBarContent';

import './ConversionBarContainer.scss';

export interface ConversionBarContainerProps
    extends ConversionBarComponentProps,
        LegacyConversionBarProps {
    compactCheckoutDisqualifications: Event['compactCheckoutDisqualifications'];
    ticketsInfo: Event['ticketsInfo'];
    salesStatus: Event['salesStatus']['sales_status'];
    isSalesEnded: boolean;
    isSoldOut: boolean;
    // isFree: boolean;
    childEvents: Event['childEvents'];
    eventId: Event['id'];
    onlyDefaultCheckoutForOnlineEvents: boolean;
    isOnlineEventMvpEnabled: boolean;
    isTESessionSelectorExperimentEnabled?: boolean;
    eventStartDate?: LocalizedDateTime;
    eventEndDate?: LocalizedDateTime;
}

export const ConversionBarContainer: React.FC<ConversionBarContainerProps> = (
    props,
) => {
    const [teSessionSelected, setTeSessionSelected] = useState(false);
    const { isListingTimedEntryExperimentActive } =
        useListingTimedEntryExperimentContext();
    const showCheckAvailabilityBtn =
        (props.isTESessionSelectorExperimentEnabled && !teSessionSelected) ||
        isListingTimedEntryExperimentActive;
    const isCondensedCheckoutExperimentEnabled = useCondensedCheckout();

    const handleConfirm = () => {
        if (props.isTESessionSelectorExperimentEnabled) {
            setTeSessionSelected(true);
        }
    };

    const content = (
        <>
            <div
                className={`conversion-bar-bordered ${
                    isCondensedCheckoutExperimentEnabled
                        ? 'conversion-bar-container--condensed'
                        : ''
                }`}
            >
                {props.children}
                {showCheckAvailabilityBtn ? (
                    <CheckAvailability
                        eventStartDate={props.eventStartDate}
                        eventEndDate={props.eventEndDate}
                        onConfirm={handleConfirm}
                        affiliateCode={props.affiliateCode}
                        isPreview={props.isPreview}
                        campaign_token={props.campaign_token}
                        promoCode={props.promoCode}
                        rsvpToken={props.rsvpToken}
                        waitlistToken={props.waitlistToken}
                    />
                ) : (
                    <div className="conversion-bar__content-wrapper">
                        <ConversionBarContent {...props} />
                    </div>
                )}
            </div>
        </>
    );

    return (
        <AnimatedConversionBar className="conversion-bar-container">
            {content}
        </AnimatedConversionBar>
    );
};
